export default function TaglineSection() {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-black via-purple-950/10 to-black">
      <div className="max-w-4xl mx-auto text-center">
        <div className="space-y-8">
          <div className="h-px w-24 bg-teal-400 mx-auto"></div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
            Curated. Archived. Timeless.
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-400 font-light leading-relaxed max-w-2xl mx-auto">
            An underground sanctuary for those who understand that real hip hop culture and music doesn't fade. With time and true representation it evolves into something eternal.
          </p>

          <div className="h-px w-24 bg-teal-400 mx-auto"></div>
        </div>
      </div>
    </section>
  );
}